import { useContext } from "react";
import { CircleLoader, PageHeader } from "components";
import { Filter, Results } from './components';
import { usersContext } from './UsersContext';
import { appUserContext } from "helpers/services";


let WorkLogs = () => {
    let service = useContext(usersContext);
    let appUserService = useContext(appUserContext);

    return (
        <>
            <PageHeader
                pageTitle={"Users"}
                addNewUrl={appUserService.currentUser?.simecClaims?.canManageSimecUsers === true ? `/user/addnew/` : undefined}
            />
            <Filter />
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false && <Results />}
        </>
    );
}

export default WorkLogs;